








import { Vue, Component } from "vue-property-decorator";
import ApplicantsTable from "@/modules/applicants/components/ApplicantsTable.vue";
@Component({
  components: {
    applicants: ApplicantsTable,
  },
})
export default class Integration extends Vue {}
